$(document).on("blur", ".js-form_input", function(evt){
    checkInput($(this));
});

$(document).on("blur", ".js-form_input_number", function(evt){
    checkInputNumber($(this));
});

$(document).on("change", ".js-form_select", function (e) {
    e.preventDefault();
    checkSelect($(this));
});

$(document).on("click", ".js-form_checkbox", function(){
    checkCheckbox($(this));
});

//Radio Buttons via Keyboard (Space or Enter) anklicken
$(document).on("keydown", ".js-form_radio_label", function(e){
    if(e.key !== " " && e.key !== "Enter") return;
    $(this).trigger('click');
    e.preventDefault();
    e.stopPropagation();
});

//Links in Checkbox Labels via Keyboard (Enter) oeffnen ohne Checkbox zu aktivieren
$(document).on("keydown", "js-text_link", function(e){
    e.stopPropagation();
    if(e.key === " ") e.preventDefault();
});

//Checkboxen via Keyboard (Space or Enter) anklicken
$(document).on("keydown", ".js-form_checkbox_label, .form_label_text-checkbox", function(e){
    let cb = $('#' + $(this).attr('for'));
    if(e.key !== " " && e.key !== "Enter") return;
    if(e.key === " ") e.preventDefault();
    cb.trigger('click');
});

$(document).on("click", ".js-form_close_block", function(){
    $(this).parents(".js-form_block").fadeOut(500);
});

$(function(){
    $(".js-form_input").each(function(){
        if($(this).val() != "") checkInput($(this));
    });
})

function checkSelect($input){
    var value = $input.find("option:selected").val();
    var required = $input.prop("required");
    var labelObject = $input.parent().find(".js-form_label");
    var labelName = labelObject.data("label");
    var valid = true;

    if(value == 0 && required){
        if(labelName != "")labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("required"));
        $input.attr("title", $input.data("required"));
        valid = false;
    }else{
        if(labelName != "")labelObject.removeClass("form_label_text-error").html(labelName);
        $input.attr("title", "");
    }

    return valid;
}

function checkInput($input){
    var value = $input.val();
    var regex = new RegExp($input.attr("pattern"));
    var maxLength = parseInt($input.attr("maxlength"));
    var labelObject = $input.parents(".form_label").find(".js-form_label");
    var labelName = labelObject.data("label");
    var valid = true;

    if(value == "" && $input.attr("required") == "required"){
        if(labelName != "")labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("error"));
        $input.attr("title", $input.data("error"));
        valid = false;
    }else if(value != "" && !regex.test($input.val())){
        if(labelName != "")labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("error"));
        $input.attr("title", $input.data("error"));
        valid = false;
    }else if(value != "" && maxLength > 0 && value.length > maxLength){
        if(labelName != "")labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("error"));
        $input.attr("title", $input.data("error"));
        valid = false;
    }else{
        if(labelName != "")labelObject.removeClass("form_label_text-error").html(labelName);
        $input.attr("title", "");
    }

    return valid;
}

function checkInputNumber($input){
    var value = $input.val();
    var min = parseInt($input.attr("min"));
    var max = parseInt($input.attr("max"));
    var labelObject = $input.parent().siblings(".js-form_label");
    var labelName = labelObject.data("label");
    var valid = true;

    if(value == "" && $input.attr("required") == "required"){
        if(labelName != "")labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("error"));
        $input.attr("title", $input.data("error"));
        valid = false;
    }else if(value != "" && min > 0 && parseInt(value) < min){
        if(labelName != "")labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("error"));
        $input.attr("title", $input.data("error"));
        valid = false;
    }else if(value != "" && max > 0 && parseInt(value) > max){
        if(labelName != "")labelObject.addClass("form_label_text-error").html(labelName + " - " + $input.data("error"));
        $input.attr("title", $input.data("error"));
        valid = false;
    }else{
        if(labelName != "")labelObject.removeClass("form_label_text-error").html(labelName);
        $input.attr("title", "");
    }

    return valid;
}

function checkCheckbox($input){
    var valid = true;

    if(!$input.is(":checked") && $input.attr("required") == "required"){
        $input.siblings(".form_checkbox_checker").addClass("form_checkbox_checker-error");
        valid = false;
    }else{
        $input.siblings(".form_checkbox_checker").removeClass("form_checkbox_checker-error");
    }
    return valid;
}

function formMsgBlockShow($element){
    $(".js-form_block").not($element[0]).slideUp(100);
    $element.slideDown(500);
}

function formMsgBlockHide(){
    $(".js-form_block").slideUp();
}

function formMsgBlockShowHide($element, timeOut){
    $(".js-form_block").not($element[0]).slideUp(100);
    $element.slideDown(500);
    setTimeout(function(){
        $element.slideUp(500);
    }, timeOut)
}

function formMsgBlockAddText($element, addText){
    $element.find(".js-form_block_text").html(hx.replace($element.find(".js-form_block_text").html(), "<br>" + addText, ""));
    $element.find(".js-form_block_text").html($element.find(".js-form_block_text").html() + "<br>" + addText)
}

function formMsgBlockSetText($element, text){
    $element.find(".js-form_block_text").text(text)
}